export default __webpack_public_path__ + "static/media/Economic preparation.637ca55f.jpg";